import { render, staticRenderFns } from "./AamsComplaintBaseCategory.vue?vue&type=template&id=36ad429b&scoped=true&"
import script from "./AamsComplaintBaseCategory.vue?vue&type=script&lang=js&"
export * from "./AamsComplaintBaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad429b",
  null
  
)

export default component.exports